import { z } from 'zod';

import { onboardingStepsSchema } from '@/entities/practice-member';
export const signUpSearchSchema = z.object({
    step: onboardingStepsSchema.optional(),
});

export type SignUpSearch = z.infer<typeof signUpSearchSchema>;
